export default __webpack_public_path__ + "static/media/Header.175422a9.png";